<template>
    <div class="business_content">
        <!-- <div class="titlebg">
            <img   :src="src"/>
        </div> -->
        <!-- <div class="content">
            <el-row :gutter="5" type="flex" align="middle">
                <el-col 
                    :md="12" :sm="24"
                    v-for="(item, index) in contentList"
                    :key="index">
                    <div style="position: relative; width: 100%;" class="contentItem">
                        <el-image 
                            ref="imageRef"
                            @mouseover="handleMouseEnter(index)"
                            style="width: 100%;"
                            :src="item.src">
                        </el-image>
                        <div class="icon" >
                            <div style="display:flex; justify-content:center">
                            </div>
                            <div class="desc">{{item.desc}}</div>
                        </div>
                        <div class="hoverBg"  @mouseleave="handleMouseLeave" :style="{background:item.bg ,  height: hoverindex == index ? hoverHeight: '' }" ref="hoverBg"></div>  
                    </div>
                </el-col>
            </el-row>  
        </div> -->
        <div class="title">
          <div class="public_title wow fadeInLeft">产品服务</div>
          <div class="desc wow fadeInLeft">信息系统运营服务、软件开发，网页设计等。</div>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="24">
                    <div 
                        style="position: relative; 
                        width: 100%;" 
                        class="contentItem wow zoomInRight">
                        <div class="icon" v-for="(item, index) in contentList"
                        @click="handleDetails(item)"
                        :key="index"  >
                            <!-- <div class="desc">{{item.title}}</div> -->
                            <img class="desc" :src="item.src" alt=""/>
                            <!-- <div class="" class="desc">{{item.desc}}</div> -->
                            <div class="detalis">{{item.desc}}</div> 
                        </div>
                    </div>
                </el-col>
            </el-row>  
        </div>
    </div>    
</template>

<script>
import { WOW } from 'wowjs'
export default {
  data() {
    return {
        // src: require('@/assets/img/business/titlebg.png'),
        contentList:[
            {
              desc: '技术开发',
              src: require('@/assets/img/business/icon1.png'),
              id: 1,
              bg:'#ddcfdb90'
            },
            {
              desc:'培训服务',
              src: require('@/assets/img/business/icon2.png'),
              id: 2,
              bg:'#decbb790'
            },
            {
              desc: '系统运营',
              src: require('@/assets/img/business/icon3.png'),
              id: 3,
              bg:`#c1adad90`
            },
            {
              desc:'网上商城',
              src: require('@/assets/img/business/icon4.png'),
              bg:`#afbfad90`,
              url: 'https://weidian.com/?userid=1765318594'
            }
        ],
        hoverHeight: '200px',
        hoverindex: null
    }
  },
  mounted() {
    new WOW().init()
  },
  methods: {
    //其他服务详情点击事件
    handleDetails(node){
        let { id, url, desc } = node
        let arr = [ '培训服务', '系统运营' ]
        if (arr.includes(desc)) {
            this.$router.push(`/product/detailInfo/${desc}`)
        } else if (id) {
            this.$router.push(`/product/details/${id}`)
        } else if (url) {
            window.open(url, '_blank')
        }
    },
    // 动态计算 hover 高度（示例：按比例放大 1.5 倍）
    handleMouseEnter(index) {
       // 获取 el-image 的 DOM 元素
       const elImage = this.$refs['imageRef'][index].$el;
        // // 方式 3：getBoundingClientRect()（精确高度，含小数）
        const rect = elImage.getBoundingClientRect();
        this.hoverindex = index
        this.hoverHeight = `${rect.height + 1}px`
       
    },
    handleMouseLeave() {
        this.hoverHeight = ''
    }
  },
}
</script>  

<style lang="scss" scoped>

    .business_content{
        width: 100%;
        padding-top: 45px;
        box-sizing: border-box;
        // background-image: url('../../assets/img/business/contentbg.png');
        // background-position: 0 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: calc(100vh);
        @media screen and (max-height: 880px) {
            height: auto;
        }
        .title{
            width: 84%;
            margin: 0 auto;
            padding-bottom: 65px;
            padding-top: 95px;
            box-sizing: border-box;
            @media screen and (max-width: 768px) {
              padding-bottom: 10px;
              padding-top: 15px;
            }
            .desc{
                font-size: 33px;
                font-family: Adobe Heiti Std, Adobe Heiti Std-R;
                font-weight: normal;
                text-align: left;
                color: #3c3d3d;
                @media screen and (max-width: 768px) {
                  font-size: 12px;
                }
            }
            
        }
        @media screen and (max-width: 768px) {
            height:auto
        }
        .titlebg{
            width: 84%;
            margin: 0 auto;
            img{
                width: 100%;
            }
        }
        .content{
            padding-top: 25px;
            width: 84%;
            margin: 0 auto;
            height: 100%;
            .contentItem{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 50px;
                .icon{
                    position: relative;
                    cursor: pointer;
                    width: 22%;
                    height: 366px;
                    background: #FEE7E4;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    @media screen and (max-width: 768px) {
                        height: 120px;
                        width: 23%;
                    }
                    .desc{
                        position: relative;
                        z-index: 1;
                        // margin-top: 15%;
                        width: 40%;
                        height: auto;
                        // background: rgba($color: #fff, $alpha: 0.3);
                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }
                    .detalis{
                        position:absolute;  
                        // left:25%;
                        // right:0;
                        cursor: pointer;
                        bottom:-9%;
                        width:90%;
                        font-size: 26px;
                        text-align: center;
                        background: #ffc2bb;
                        color: #000;
                        padding: 10px;
                        @media screen and (max-width: 768px) {
                            font-size: 12px;
                            padding: 0;
                        }
                    }
                    .detalis:hover{
                        background: #cb5141;
                        color: #fff;
                    }
                }
                
                
            }
            // .contentItem:hover .hoverBg{
            //     height:var(--hoverHeight);
            // }
        }

    }
</style>